import { defineComponent } from "vue";
import { notificationsModule } from "@/store/modules/notifications";
import { NotificationsActions } from "@/store/modules/notifications/actions";
import { solutionModule } from "@/store/modules/solution";
import { SolutionActions } from "@/store/modules/solution/actions";
import { SolutionGetters } from "@/store/modules/solution/getters";
import backendResponseErrors from "./BackendResponseErrors.json";

export interface SolutionTokenData {
    token: string;
    marketStatus: string;
}

export default defineComponent({
    computed: {
        ...solutionModule.mapGetters({
            errors: SolutionGetters.Errors,
            loading: SolutionGetters.Loading,
            caseModel: SolutionGetters.Case
        }),
        tokenData(): SolutionTokenData | null {
            const token = this.$route.query.token as string;
            const marketStatus = this.$route.query.marketStatus as string;
            if (token && marketStatus) return { token, marketStatus };
            return null;
        }
    },
    methods: {
        ...solutionModule.mapActions({
            getSolutionCase: SolutionActions.GetSolutionCase
        }),
        ...notificationsModule.mapActions({
            showError: NotificationsActions.NotifyError
        }),
        displayErrors(): void {
            if (this.errors) {
                let errorMessage: string;
                if (Object.keys(backendResponseErrors).includes(this.errors)) {
                    errorMessage =
                        this.getBackendResponseErrors()[this.errors].message;
                } else {
                    errorMessage = this.errors;
                }
                this.showError(errorMessage);
            }
        },
        getBackendResponseErrors(): { [K: string]: { message: string } } {
            return backendResponseErrors as {
                [K: string]: { message: string };
            };
        }
    },
    watch: {
        errors(newVal: string | null) {
            if (newVal && newVal.length) {
                this.displayErrors();
            }
        }
    }
});
